import React from 'react';
import { useTranslation } from 'react-i18next';
import { BooleanCollection } from './FiltersDrawer.types';
import { BooleanChips } from './BooleanChips';
import { Property } from '@/api/types/categories.types';

type Props = {
  property: Property;
  collection: BooleanCollection;
  setCollection: React.Dispatch<React.SetStateAction<BooleanCollection>>;
};

export const BooleanOptions = ({
  property,
  collection,
  setCollection,
}: Props) => {
  const { t } = useTranslation();

  const { name, legacyResourceId } = property;
  const options = [
    { label: t('common.no_matter'), value: undefined },
    { label: t('common.yes'), value: true },
    { label: t('common.no'), value: false },
  ];

  function handleChange(value: boolean | undefined) {
    setCollection(prev => ({ ...prev, [property.legacyResourceId]: value }));
  }

  return (
    <BooleanChips
      title={name}
      value={collection[legacyResourceId]}
      options={options}
      onChange={handleChange}
      dataTestId={`boolean-property-${legacyResourceId}`}
    />
  );
};
